<template>
  <div>
    <v-btn @click="open = true">Open Side Quests</v-btn>
    <SideQuestsDrawer v-model="open" :quests="quests" />
  </div>
</template>

<script>
import SideQuestsDrawer from "./SideQuestsDrawer.vue";

export default {
  name: "father",
  components: { SideQuestsDrawer },
  data() {
    return {
      open: true,
      quests: [
        {
          id: 1,
          period: "weekly",
          status: "active",
          bullets: 5,
          completedBullets: 5,
          title: "5 in a Row",
          subtitle: "You logged in 5 days in a row",
          reward: "+100 pts",
        },
        {
          id: 2,
          period: "weekly",
          status: "disabled",
          bullets: 0,
          completedBullets: 0,
          title: "Start your first live tournament",
          subtitle: "You created a live tournament",
          reward: "+20 pts",
        },
        {
          id: 3,
          period: "weekly",
          status: "disabled",
          bullets: 0,
          completedBullets: 0,
          title: "Create a community",
          subtitle: "You started your own community",
          reward: "+20 pts",
        },
        {
          id: 4,
          period: "weekly",
          status: "disabled",
          bullets: 0,
          completedBullets: 0,
          title: "Start your first live tournament",
          subtitle: "You logged in 5 days in a row",
          reward: "+20 pts",
        },
        {
          id: 5,
          period: "weekly",
          status: "disabled",
          bullets: 0,
          completedBullets: 0,
          title: "Start your first live tournament",
          subtitle: "You logged in 5 days in a row",
          reward: "+20 pts",
        },
        {
          id: 6,
          period: "daily",
          status: "active",
          bullets: 3,
          completedBullets: 2,
          title: "Daily Login",
          subtitle: "Log in today",
          reward: "+10 pts",
        },
      ],
    };
  },
  watch: {
  open(v) { console.log("open changed:", v); }
}
};
</script>
